import { Toaster } from "sonner";

export function ClientToaster() {
  return <Toaster richColors position="top-center" />;
}
